import { Stack, Typography } from '@rossum/ui/material';
import { HighlightMatches } from './searchMatching';
import { SuggesterPopoverMode, VariableCompletion } from './types';

type MenuItemContentAnnotationVarProps = {
  annotationVariable: VariableCompletion;
  search: string;
  mode?: SuggesterPopoverMode;
};

export const MenuItemContentAnnotationVar = ({
  search,
  annotationVariable,
  mode,
}: MenuItemContentAnnotationVarProps) => {
  return (
    <Stack spacing={0.5} sx={{ width: '100%' }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">
          <HighlightMatches
            search={search}
            text={annotationVariable.description}
          />
        </Typography>
      </Stack>
      <Typography
        variant="caption"
        color="info.main"
        sx={{
          // TODO: add "code" variant to MUI typography
          fontFamily:
            "Monaco, Menlo, 'Ubuntu Mono', Consolas, 'Source Code Pro', source-code-pro, monospace",
        }}
      >
        <HighlightMatches
          search={search}
          text={annotationVariable.value}
          mode={mode}
        />
      </Typography>
    </Stack>
  );
};
